import { render, staticRenderFns } from "./mbWay.vue?vue&type=template&id=32255650"
import script from "./mbWay.vue?vue&type=script&lang=js"
export * from "./mbWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Field: require('/vercel/path0/components/ui/field.vue').default})
